<app-mcl-wrapper>

  <app-mcl-header logosource="assets/theme/mclane/img/McLane_logo_wht.png">
    <app-menu></app-menu>
  </app-mcl-header>
  <app-mcl-menudrawer class="drawerContainer" [titleHeader]="'Welcome to Online Invoicing'">
    <router-outlet></router-outlet>
  </app-mcl-menudrawer>
  <app-mcl-footer class="gridfooter">
    <div class="copyright">
      <p class="cptext">
        © Copyright 2024 McLane Company Incorporated, Temple,TX. All Rights Reserved.
        <br>
        v{{ env.version }} ({{ env.buildEnv }})
      </p>
    </div>
  </app-mcl-footer>
</app-mcl-wrapper>
<div *ngIf="loadingIndicator.isLoading | async" class="k-icon k-i-loading"></div>
<mat-progress-bar
  *ngIf="loadingIndicator.isLoading | async"
  mode="indeterminate"
  color="warn"
  style="position: absolute; top: 0; z-index: 5000;"
>
</mat-progress-bar>


